import React from 'react';
import { 
  Building2, Radio, Heart, GraduationCap, 
  Landmark, Headphones, Factory, ShoppingCart 
} from 'lucide-react';
import { verticals } from '../data/mock';

const Industries = () => {
  const iconMap = {
    "Building2": Building2,
    "Radio": Radio,
    "Heart": Heart,
    "GraduationCap": GraduationCap,
    "Landmark": Landmark,
    "Headphones": Headphones,
    "Factory": Factory,
    "ShoppingCart": ShoppingCart
  };

  return (
    <section id="industries" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-cyan-100 rounded-full mb-4">
            <span className="text-cyan-700 font-semibold text-sm">Industries</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {verticals.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Delivering specialized IT solutions across diverse sectors with deep industry expertise
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {verticals.sectors.map((sector, index) => {
            const IconComponent = iconMap[sector.icon];
            return (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 group"
              >
                <div className="mb-4 p-3 bg-gradient-to-br from-cyan-100 to-lime-100 rounded-lg inline-block group-hover:scale-110 transition-transform duration-300">
                  {IconComponent && <IconComponent className="text-cyan-700" size={28} />}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {sector.name}
                </h3>
                <p className="text-gray-600 text-sm">
                  {sector.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-cyan-50 to-lime-50 rounded-2xl p-8 border border-cyan-200">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              Your Industry, Our Expertise
            </h3>
            <p className="text-gray-700 text-lg max-w-2xl mx-auto">
              With experience across multiple verticals, we understand the unique challenges 
              and requirements of your industry. Let us help you achieve your IT goals.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
